export const QuotationInfoValidation = (formData) => {
    const errors = {};
   
    if (!formData.vc_Notes || formData.vc_Notes=="") {
        errors.vc_Notes = 'This field is required';
    }
    if (!formData.vc_User1 || formData.vc_User1=="0") {
        errors.vc_User1 = 'This field is required';
    }
    if (!formData.vc_User2 || formData.vc_User2=="0") {
        errors.vc_User2 = 'This field is required';
    }
    
    return errors;
};
